type ApplicationStageProps = {
  stage: number;
};

const ApplicationStage = ({ stage }: ApplicationStageProps) => {
  if (isNaN(stage)) {
    return <span>{' - '}</span>;
  }

  return <span className="">{stage}</span>;
};

export default ApplicationStage;
